import { Outlet } from "react-router-dom";
import Sidebar from "./SiderBar";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import clsx from "clsx";
import menu from '../data/menu_backoffice.json';

interface BackofficeLayoutProps {
	headerFixed?: boolean;
	siteName?: string;
	menuMobilePosition?: string;
	containerClasses?: string;
}

export default function BackofficeLayout({
	headerFixed,
	siteName,
	menuMobilePosition,
	containerClasses
}: BackofficeLayoutProps) {
	return (
		<div className="h-screen flex flex-col bg-gray-50">
			<NavBar fixed={headerFixed} shadow menuMobilePosition={menuMobilePosition} />
			<div className={clsx("flex flex-1 max-h-[calc(100vh-var(--navbar-height)-2rem)]",
				containerClasses)}>
				<Sidebar menu={menu} />
				<main className="flex-1 p-6 -my-4 overflow-y-auto">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
